import React from 'react';
import PropTypes from 'prop-types';
import SidePage from './SidePage/index.tsx';

const MAX_SLIDER_WIDTH = 600;
const MIN_SLIDER_WIDTH = 250;
// This is set in routerContainer.scss.
const SPLIT_SCREEN_THRESHOLD = 1000;

// See RouterContainer.scss.
export const getSliderWidth = () => {
  let innerWidth = window.innerWidth * 0.8;
  if (window.innerWidth > SPLIT_SCREEN_THRESHOLD) {
    innerWidth = window.innerWidth * 0.45;
  }
  let width = innerWidth * 0.8;
  width = Math.min(MAX_SLIDER_WIDTH, width);
  width = Math.max(MIN_SLIDER_WIDTH, width);
  return width;
};

const containerStyles = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  alignItems: 'flex-start',
};

const itemStyles = {
  padding: '5px',
};

const RouteContainer = ({
  children, locationKey,
}) => (
  <div id="route_outer_container">
    <div
      id="route_container"
      style={containerStyles}
    >
      <div className={`route_container__item view_${locationKey}`} style={itemStyles}>
        {children}
      </div>
      <div className="route_container__item" style={itemStyles}>
        <SidePage />
      </div>
    </div>
  </div>
);

RouteContainer.propTypes = {
  children: PropTypes.node.isRequired,
  locationKey: PropTypes.string.isRequired,
};

export default RouteContainer;
